import React, { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { PRODUCTS } from '../data/products';
import { useCartStore } from '../store/useCartStore';
export function ProductPage() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const product = PRODUCTS.find(p => p.id === Number(id));
  const {
    addItem
  } = useCartStore();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);
  if (!product) {
    return <div className="min-h-screen flex items-center justify-center bg-brand-bg" data-id="element-234" data-mp="ypbb2ebvcji">
        <div className="text-center" data-id="element-235" data-mp="exypxxmvxyld">
          <h1 className="text-3xl font-serif font-normal text-brand-primary mb-4" data-id="element-236" data-mp="9xapymgoi7f0">
            Товар не знайдено
          </h1>
          <button onClick={() => navigate('/')} className="text-brand-primary text-sm uppercase tracking-[0.15em] font-medium hover:text-brand-accent transition-colors duration-200" data-id="element-237" data-mp="1qarekzkdq6x7">
            Повернутися на головну
          </button>
        </div>
      </div>;
  }
  const features = [{
    title: 'Повністю магнітна основа',
    desc: 'Надійно тримається на холодильнику, не сповзає.'
  }, {
    title: 'Маркер з губкою в комплекті',
    desc: 'Легко пише та стирається без слідів.'
  }, {
    title: 'Багаторазове використання',
    desc: 'Пишіть, стирайте та плануйте знову і знову.'
  }];
  return <div className="min-h-screen bg-brand-bg text-brand-text selection:bg-brand-accent/20 selection:text-brand-primary font-sans pt-24" data-id="element-238" data-mp="xyzmtsz92nmq">
      <main className="max-w-7xl mx-auto px-6 lg:px-8 py-12 lg:py-24" data-id="element-239" data-mp="12xkgtanwsb2q">
        <Link to="/" className="inline-flex items-center gap-2 text-brand-muted hover:text-brand-primary font-medium mb-14 transition-colors duration-200 text-xs tracking-[0.15em] uppercase" data-id="element-240" data-mp="17pc7rmaz8ite">
          <ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.5} data-id="element-241" data-mp="f7gnpx8cjtpz" />
          Назад до колекції
        </Link>

        <div className="flex flex-col lg:flex-row gap-14 lg:gap-24" data-id="element-242" data-mp="76ir1wvthyjf">
          {/* Мобільний заголовок та бейдж */}
          <div className="lg:hidden flex flex-col items-center text-center gap-4 mb-4" data-id="element-243" data-mp="34e0j70o1i10">
            <div className="inline-flex items-center gap-2" data-id="element-244" data-mp="gx3nbdo0qqz6">
              <span className="w-1.5 h-1.5 rounded-full bg-brand-accent" data-id="element-245" data-mp="byikr7lanv7k" />
              <span className="font-medium text-xs uppercase tracking-[0.2em] text-brand-muted" data-id="element-246" data-mp="3kelqv8wrdbts">
                В наявності
              </span>
            </div>
            <h1 className="text-4xl font-serif font-normal text-brand-primary leading-tight tracking-tight" data-id="element-247" data-mp="3getioxba17oy">
              {product.title}
            </h1>
          </div>

          {/* Фото */}
          <div className="w-full lg:w-1/2 flex-shrink-0" data-id="element-248" data-mp="3pc3x2rje5cy3">
            <motion.div initial={{
            opacity: 0,
            scale: 0.97
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.7,
            ease: [0.23, 1, 0.32, 1]
          }} className="relative w-full overflow-hidden border border-brand-primary/10 bg-brand-surfaceAlt aspect-[4/5]" data-id="element-249" data-mp="19m1236t0u5n6">
              <img src={product.img} alt={product.title} className="absolute inset-0 w-full h-full object-cover" data-id="element-250" data-mp="2rlqq89zk1cxm" />
            </motion.div>
          </div>

          {/* Інформація */}
          <div className="w-full lg:w-1/2 flex flex-col text-center lg:text-left" data-id="element-251" data-mp="369brrzgs743f">
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.15,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col h-full" data-id="element-252" data-mp="36bfuie2y1x24">
              <div className="hidden lg:flex flex-col gap-5 mb-8" data-id="element-253" data-mp="31h246q352g4b">
                <div className="inline-flex items-center gap-2 w-fit" data-id="element-254" data-mp="3p7e9ruaww0rq">
                  <span className="w-1.5 h-1.5 rounded-full bg-brand-accent" data-id="element-255" data-mp="3p639w5kl7d5w" />
                  <span className="font-medium text-xs uppercase tracking-[0.2em] text-brand-muted" data-id="element-256" data-mp="3tzz5509gulxd">
                    В наявності
                  </span>
                </div>
                <h1 className="text-5xl lg:text-6xl font-serif font-normal text-brand-primary leading-tight tracking-tight" data-id="element-257" data-mp="20cyt8x6r3ucg">
                  {product.title}
                </h1>
              </div>

              <p className="text-lg text-brand-text mb-12 leading-relaxed font-light" data-id="element-258" data-mp="1remx6fn484cm">
                {product.fullDesc}
              </p>

              <div className="mb-14 text-left" data-id="element-259" data-mp="2k1ps6xsl1wy4">
                <h3 className="font-serif font-normal text-brand-primary text-xl mb-4 text-center lg:text-left" data-id="element-260" data-mp="2k30x50xrlaqt">
                  Що ви отримуєте:
                </h3>
                <div className="border-t border-brand-primary/10" data-id="element-261" data-mp="2acg03hxqoea0">
                  {features.map((item, idx) => <div key={idx} className="flex gap-6 py-5 border-b border-brand-primary/10" data-id="element-262" data-mp="37sdeio38wp47" data-mpi={idx}>
                      <span className="text-sm font-medium text-brand-accent tabular-nums pt-0.5 w-6 flex-shrink-0" data-id="element-263" data-mp="3abqa5qd95i0i">
                        {String(idx + 1).padStart(2, '0')}
                      </span>
                      <div data-id="element-264" data-mp="3ka60vs8dap9h">
                        <span className="font-serif font-normal text-brand-primary block text-base mb-1" data-id="element-265" data-mp="3k8uvxp36rbgs">
                          {item.title}
                        </span>
                        <span className="text-brand-text text-sm leading-relaxed font-light" data-id="element-266" data-mp="3tavvislw69lm">
                          {item.desc}
                        </span>
                      </div>
                    </div>)}
                </div>
              </div>

              <div className="mt-auto pt-2 flex flex-col sm:flex-row items-center sm:items-end justify-between gap-8" data-id="element-267" data-mp="6xdsz2lrbkxx">
                <div className="text-center sm:text-left w-full sm:w-auto" data-id="element-268" data-mp="fvzi5glqhy7o">
                  <p className="text-xs text-brand-muted font-medium uppercase tracking-[0.2em] mb-2" data-id="element-269" data-mp="ftv4w81y3muq">
                    Інвестиція в спокій
                  </p>
                  <div className="text-4xl font-serif font-normal text-brand-primary" data-id="element-270" data-mp="2gygtb84f55g2">
                    {product.price}{' '}
                    <span className="text-lg font-sans font-light text-brand-muted" data-id="element-271" data-mp="2cuitev79rqly">грн</span>
                  </div>
                </div>
                <button onClick={() => addItem(product)} className="w-full sm:w-auto px-10 py-4 bg-brand-primary hover:bg-brand-primaryHover text-white text-sm uppercase tracking-[0.15em] font-medium transition-colors duration-200 flex items-center justify-center gap-3 group" data-id="element-272" data-mp="2lws3jjymlhyt">
                  Замовити зараз
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" data-id="element-273" data-mp="39k8lbso9lubi" />
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-brand-primary text-brand-bg py-16 mt-24" data-id="element-274" data-mp="1aaa4kx1szswj">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-275" data-mp="3lx3yspovcokr">
          <div className="text-xl font-serif font-normal tracking-tight" data-id="element-276" data-mp="3qw6sxf3b9ady">
            MyPlaner<span className="text-brand-accent" data-id="element-277" data-mp="3d4s7z2puez49">.</span>
          </div>
          <div className="text-brand-bg/40 text-xs font-light" data-id="element-278" data-mp="3d2ftizjan6vy">
            © {new Date().getFullYear()} MyPlaner. Всі права захищені.
          </div>
        </div>
      </footer>
    </div>;
}